import { Navigate, useRoutes } from 'react-router-dom'
import Home from '../pages/home'
import Baselayout from './layout/Baselayout'
import Contact from '../pages/Contact'
import Individuality from '../pages/Individuality'
import Delivery from '../pages/Delivery'
import { observer } from 'mobx-react-lite'
import Responasbility from '../pages/Responasbility'
import Earning from '../pages/Earning'
import Team from '../pages/Team'

const routes = [

    {
        path: '/', element: <Baselayout />, children: [
            {
                path: '', element: <Home />,
            },
            {
                path: 'contact', element: <Contact />,
            },
            {
                path: 'individuality', element: <Individuality />
            },
            {
                path: 'delivery', element: <Delivery />
            },
            {
                path: 'responsibility', element: <Responasbility />
            },
            {
                path: 'team', element: <Team />
            },
            {
                path: 'earning', element: <Earning />
            }

        ]
    }

]
const Route = () => {
    const route = useRoutes(routes)
    return route
}

export default observer(Route)